import 'Styles/templates/page.swym.scss';

import WishlistSharePage from '../vue/wishlist/wishlist-share-page';

WishlistSharePage();